var Vue = require('vue')
var VueRouter = require('vue-router')
Vue.use(VueRouter)

require('common/validators')(Vue)

require('material-design-lite')

var startApp = function () {
  var local = require('common/store/local')
  local.put('client.options', {
    auth: 'Basic ' + window.btoa('admin:secret'),
    scope: 'admin'
  })
  var router = new VueRouter({
    hashbang: false,
    history: true,
    transitionOnLoad: true
  })
  var routes = require('./routes')
  router.map(routes)
  router.beforeEach(function (transition) {
    var local = require('common/store/local')
    console.log(transition)
    if (transition.to.auth === 'private' && !local.get('client.logged')) {
      transition.redirect('/admin/login')
      return
    }
    if (!transition.to.auth === 'public' && local.get('client.logged')) {
      transition.redirect('/admin')
      return
    }
    transition.next()
  })

  var app = require('./Admin')
  router.start(app, 'app')
  window.document.querySelector('#loading').style.display = 'none'
}

var mainSiteLang = 'en'
if (window.location.href.split('lang=').length > 1) {
  mainSiteLang = window.location.href.split('lang=')[1].split('&')[0]
}
require('api/init')(mainSiteLang, function (data) {
  var local = require('../common/store/local')
  console.log(local)
  local.put('client.language', mainSiteLang)
  return data
}).then(function (data) {
  console.log('register filters')
  var filters = require('common/filters')(data)

  Vue.filter('label', filters.label)
  Vue.filter('lookup', filters.lookup)
  Vue.filter('lookupValue', filters.lookupValue)
  Vue.filter('lookupLabel', filters.lookupLabel)
  Vue.filter('makeDate', filters.makeDate)
}).then(startApp)



// WEBPACK FOOTER //
// ./src/admin/index.js